var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4402_21862)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.80514 18.1601C7.07874 18.8971 7.69836 19.3946 8.45538 19.4855L11.3891 19.839C13.2149 20.0588 15.1086 19.021 16.1396 17.2352C16.6989 16.2665 15.964 15.1848 14.9649 15.5068C13.6134 15.9429 12.2237 16.0807 10.8849 15.9102L8.70284 15.6328C7.433 15.4714 6.34463 16.9212 6.80514 18.1601Z",
    fill: "#EBE298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2206 19.8321C18.0226 19.8968 15.4784 19.5763 15.4438 20.5997C15.4077 21.6648 17.6591 21.0041 17.6591 22.2407C17.6591 24.1389 6.34082 24.0963 6.34082 22.2407C6.34082 21.0041 8.59223 21.6648 8.55623 20.5997C8.52159 19.5763 5.9774 19.8968 3.77934 19.8321C1.80412 19.7741 0.309977 19.5933 0.352446 18.8088C0.42168 17.5295 5.96005 18.3002 5.96005 17.1457C5.96005 15.9518 3.60627 16.762 3.60627 15.5254C3.60627 14.8857 4.99087 14.4593 8.21005 14.4593",
    stroke: "#3E4E56",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79 14.4593C19.0092 14.4593 20.3938 14.8858 20.3938 15.5254C20.3938 16.762 18.04 15.9518 18.04 17.1458C18.04 18.3002 23.5784 17.5295 23.6476 18.8088C23.6757 19.3258 23.0362 19.5807 22.0314 19.7109",
    stroke: "#3E4E56",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2008 8.76467L8.67913 11.4004C7.20318 13.9568 9.04813 17.1523 12 17.1523C14.9519 17.1523 16.7969 13.9568 15.3209 11.4004L12 5.64842L11.1751 7.07717",
    stroke: "#3E4E56",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0314 1.99219L14.5496 4.55859C13.8911 5.6992 14.7143 7.125 16.0314 7.125C17.3485 7.125 18.1716 5.6992 17.5131 4.55859L16.0314 1.99219Z",
    fill: "#3ABBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56231 0.351562L8.52717 2.14453C8.06709 2.94141 8.64215 3.9375 9.56231 3.9375C10.4825 3.9375 11.0575 2.94141 10.5974 2.14453L9.56231 0.351562Z",
    stroke: "#3E4E56",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4402_21862"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalWater);
export default __webpack_public_path__ + "static/media/total-water.1bc86b842dceb0a74e7998a3e4df0f8a.svg";
export { ForwardRef as ReactComponent };